import React from "react";
import "./Wedding.css";
import { openWhatsApp } from "../utils/whatsapp";

// ✅ Import hero and product images
import weddingHero from "../Assets/wedding-banner2.webp";
import wed1 from "../Assets/wedding2.jpg";
import wed2 from "../Assets/wedding1.jpg";
import wed3 from "../Assets/wed3.jpg";
import wed4 from "../Assets/wed4.jpg";
import wed5 from "../Assets/wed5.jpg";
import wed6 from "../Assets/wed6.jpg";
import wed7 from "../Assets/wed7.jpg";
import wed8 from "../Assets/wed8.jpg";
import wed9 from "../Assets/wed9.jpg";
import wed10 from "../Assets/wed11.jpg";
import wed11 from "../Assets/wed10.jpg";
import wed12 from "../Assets/wed12.jpg";
import wed13 from "../Assets/wed14.jpg";
import wed14 from "../Assets/wed13.jpg";
import wed15 from "../Assets/wed15.jpg";







const Wedding = () => {
    return (
        <div className="wedding-page">
            {/* 🌟 Hero Section */}
            <section className="wedding-hero">
                <img
                    src={weddingHero}
                    alt="Wedding & Engagement"
                    className="wedding-hero-img"
                />

                {/* Overlay Card (Like Category Page) */}
                <div className="wedding-overlay">
                    <div className="wedding-hero-card">
                        <h1>Wedding & Engagement</h1>
                    </div>
                </div>
            </section>

            {/* 💎 Title */}
            <div className="wedding-title">
                <h2>Wedding & Engagement Collection</h2>
                <hr />
            </div>

            {/* 💍 Product Grid */}
            <section className="wedding-collection">
                <div className="collection-grid">
                    {[wed1, wed2, wed3, wed4, wed5, wed6, wed7, wed8, wed9, wed10, wed11, wed12, wed13, wed14, wed15].map(
                        (img, index) => {
                            
                            const itemCode = `WE00${index + 1}`;
                            return (
                                <div className="wedding-collection-item" key={index}>
                                    <img src={img} alt={`Wedding item ${index + 1}`} />
                                    
                                    <span>Item code: {itemCode}</span>
                                    <button onClick={() => openWhatsApp( itemCode)}>Inquire Now</button>
                                </div>
                            );
                        }
                    )}
                </div>
            </section>
        </div>
    );
};

export default Wedding;
